<template>
  <div class="boq-creator-print-view">
    <table class="table table-bordered">
        <thead>
            <tr class="">
                <th>{{ $t('S/N') }}</th>
                <th> {{ $t('Description') }}</th>
                <th class="text-center"> {{ $t('Image') }}</th>
                <th> {{ $t('Space ID') }}</th>
                <th> {{ $t('Unit') }}</th>
                <th class="text-end"> {{ $t('Quantity') }}</th>
                <th class="text-end"> {{ $t('Rate') }}({{currencySign}})</th>
                <th class="text-end"> {{ $t('Total') }}({{currencySign}})</th>
            </tr>
        </thead> 
        <tbody>
            <BoqCreatorPrintViewRow :sections="safeSections" :IsOpenBook="IsOpenBook" :boqId="boqId" :imageSummaries="imageSummaries" :imageContextType="imageContextType" @open-images="imageItem = $event" />
            <tr class="fw-bold" >
                <td ></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td class="text-end" >{{$t('Overall Total')}}</td>
                <td class="text-end">{{ ReformatNumber(overallSellTotal) }}</td>
            </tr>
        </tbody>
    </table>
    <BoqItemImagesModal v-if="imageItem && boqId" :boqId="boqId" :item="imageItem" :imageContextType="imageContextType || 'boq'" :allowEdit="false" @close="imageItem = null" />
  </div>
</template>

<script>
import {ReformatNumber} from '@/helpers/utilities.js'
import BoqCreatorPrintViewRow from '../boq/BoqCreatorPrintViewRow.vue'
import BoqItemImagesModal from '../boq/BoqItemImagesModal.vue'
export default{
    name : 'BoqCreatorPrintView',
    props : ['IsOpenBook','lineItems','currencySign','sectionsList','boqId','imageSummaries','imageContextType'],
    components : {
        BoqCreatorPrintViewRow,BoqItemImagesModal
    },
    data(){
        return {imageItem : null}
    },
    methods : {
        ReformatNumber
    },
    computed : {
        safeSections(){
            return this.sectionsList?.sections || []
        },
        overallSellTotal(){
            return this.sectionsList?.overAllTotal?.sellTotal || 0
        }
    },
}
</script>
